import React, { forwardRef, Ref, SVGProps } from 'react'

function _IconFrameTool(props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
      <rect x="0.800003" width="24" height="24" rx="6" fill={props.fill ?? '#F2F5F7'} />
      <path
        d="M13.75 9.14999C13.6584 9.24345 13.6071 9.36911 13.6071 9.49999C13.6071 9.63087 13.6584 9.75653 13.75 9.84999L14.55 10.65C14.6435 10.7416 14.7692 10.7929 14.9 10.7929C15.0309 10.7929 15.1566 10.7416 15.25 10.65L17.135 8.76499C17.3865 9.32058 17.4626 9.93961 17.3533 10.5396C17.244 11.1395 16.9544 11.6919 16.5232 12.1231C16.092 12.5543 15.5396 12.8439 14.9396 12.9532C14.3397 13.0625 13.7206 12.9864 13.165 12.735L9.71004 16.19C9.51113 16.3889 9.24135 16.5007 8.96004 16.5007C8.67874 16.5007 8.40896 16.3889 8.21004 16.19C8.01113 15.9911 7.89938 15.7213 7.89938 15.44C7.89938 15.1587 8.01113 14.8889 8.21004 14.69L11.665 11.235C11.4136 10.6794 11.3375 10.0604 11.4468 9.46042C11.5561 8.86046 11.8457 8.30807 12.2769 7.87685C12.7081 7.44563 13.2605 7.15607 13.8605 7.04676C14.4604 6.93745 15.0794 7.01357 15.635 7.26499L13.755 9.14499L13.75 9.14999Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconFrameTool = forwardRef(_IconFrameTool)
